import React from "react";
import { reduxForm } from "redux-form";
import { CriteriaResponseCheckboxes } from "../Fields/CriteriaResponseCheckboxes";
import { presaleCriteriaOptions } from "../MetricsDetailUtils";
import { ChannelsCheckboxes } from "../Fields/ChannelsCheckboxes";
import Stack from "@mui/material/Stack";
import styles from "../Utilities/Styles.module.css";

const PreSaleFilterDropdownForm = ({
                                       handles,
                                       setSelectedChannels,
                                       selectedChannels,
                                       selectedCheckboxes,
                                       setSelectedCheckboxes,
                                       allChannelsSelected,
                                       setAllChannelsSelected
}) => {
    const criteriaHeading = "Criteria"

    return(
        <Stack direction={'row'} spacing={1}>
            <ChannelsCheckboxes
                handles={handles}
                selectedChannels={selectedChannels}
                setSelectedChannels={setSelectedChannels}
                allChannelsSelected={allChannelsSelected}
                setAllChannelsSelected={setAllChannelsSelected}
            />

            <div className={`${styles['ml15']} filter-all-criteria`}>
                <CriteriaResponseCheckboxes
                    criteriaOptions={presaleCriteriaOptions}
                    selectedCheckboxes={selectedCheckboxes}
                    setSelectedCheckboxes={setSelectedCheckboxes}
                    criteriaHeading={criteriaHeading}
                />
            </div>
        </Stack>
    )
}

const preSaleFilterDropdownForm = reduxForm({
    form: 'PreSaleFilterDropdownForm'
})(PreSaleFilterDropdownForm);

export { preSaleFilterDropdownForm as PreSaleFilterDropdownForm }